export const ANALYTICS_NATIVE_THEME_CLASSIFIER_DATA = [
  {
    title: 'Финансовые услуги',
    description:
      'Вклады, банковские карты, кредитные карты, кредиты, инвестиционные продукты, пенсионные планы'
  },
  {
    title: 'Страхование',
    description:
      'Автострахование, страхование жизни, страхование недвижимости, медицинское страхование, страхование путешествий'
  },
  {
    title: 'Автотовары и услуги',
    description: 'Автомобили, запчасти, автосервис, аксессуары для автомобилей, автострахование'
  },
  {
    title: 'Телекоммуникации',
    description: 'Мобильная связь, интернет-услуги, кабельное и спутниковое ТВ, VoIP'
  },
  {
    title: 'Образование и курсы',
    description:
      'Высшее образование, дополнительное образование, онлайн-курсы, корпоративное обучение, языковые курсы'
  },
  {
    title: 'Здравоохранение и лекарства',
    description:
      'Медицинские услуги, фармацевтика, медицинское оборудование, здоровье и питание, стоматология'
  },
  {
    title: 'Недвижимость',
    description:
      'Продажа и аренда жилья, коммерческая недвижимость, ипотека, управление недвижимостью, строительные услуги'
  },
  {
    title: 'Интерьер и дом',
    description: 'Мебель, декор, бытовая техника, ремонт и отделка'
  },
  {
    title: 'Одежда и аксессуары',
    description: 'Одежда, обувь, украшения, сумки и аксессуары, часы'
  },
  {
    title: 'Красота и уход',
    description: 'Косметика, парфюмерия, уход за кожей, салоны красоты, спа и велнес'
  },
  {
    title: 'Техника и электроника',
    description: 'Смартфоны, бытовая техника, аудио и видеотехника, гаджеты, техника для дома'
  },
  {
    title: 'Компьютеры и IT',
    description:
      'Программное обеспечение, мобильные приложения, аппаратное обеспечение, IT-услуги, облачные технологии, кибербезопасность, IT сервисы'
  },
  {
    title: 'Спорт и отдых',
    description: 'Спортивные товары, фитнес-клубы, туризм, активный отдых, спортивные мероприятия'
  },
  {
    title: 'Книги и литература',
    description: 'Художественная литература, учебные пособия, электронные книги, журналы, комиксы'
  },
  {
    title: 'Товары и услуги для детей',
    description:
      'Детская одежда, игрушки, детское питание, товары для новорожденных, образовательные игры'
  },
  {
    title: 'Питание и рестораны',
    description: 'Рестораны, кафе, доставка еды, продуктовые магазины, здоровое питание'
  },
  {
    title: 'Хобби и рукоделие',
    description:
      'Товары для творчества, наборы для рукоделия, музыкальные инструменты, коллекционирование, фотографирование'
  },
  {
    title: 'Музыка и развлечения',
    description:
      'Концерты, кинотеатры, театры, музыкальные альбомы, видеоигры, онлайн кинотеатры, онлайн стриминг, кино, фильмы'
  },
  {
    title: 'Туризм и путешествия',
    description: 'Туры, отели, авиабилеты, круизы, экскурсии'
  },
  {
    title: 'Юридические услуги',
    description:
      'Юридические консультации, регистрация компаний, судебные споры, нотариальные услуги, интеллектуальная собственность'
  },
  {
    title: 'Строительство и ремонт',
    description:
      'Строительные работы, ремонтные услуги, строительные материалы, дизайн интерьера, ландшафтные работы'
  },
  {
    title: 'Сад и огород',
    description: 'Растения, садовый инвентарь, удобрения, ландшафтный дизайн, озеленение'
  },
  {
    title: 'Домашние животные',
    description:
      'Корма, аксессуары для животных, ветеринарные услуги, уход за животными, питомцы на продажу'
  },
  {
    title: 'Такси и транспорт',
    description: 'Такси, поезда, автобусы, маршруты, попутки, автостоп'
  },
  {
    title: 'Искусство и ремесла',
    description:
      'Художественные галереи, народное искусство, материалы для художников, ремесленные изделия, антиквариат'
  },
  {
    title: 'Экология и окружающая среда',
    description:
      'Экологически чистые продукты, экологические технологии, переработка отходов, зеленая энергия, экологические проекты'
  },
  {
    title: 'Религия',
    description: 'Религия, религиозная литература, христианство, буддизм, ислам, индуизм, иудаизм'
  },
  {
    title: 'Психология',
    description:
      'Психотерапия, консультации по личностному росту, семейное консультирование, тесты на профориентацию, курсы по управлению стрессом, психологические тренинги, вебинары по саморазвитию, книги по психологии, работа с тревогой и депрессией, техники медитации и релаксации'
  },
  {
    title: 'Эзотерика',
    description:
      'Гороскопы и астрология, таро и гадания, ритуалы и обряды, чакровое исцеление, медитативные практики, энергетическая работа и очищение ауры'
  },
  {
    title: 'Оптовая торговля',
    description: 'Оптовые поставки, товары для бизнеса, сырье, упаковочные материалы'
  },
  {
    title: 'События и мероприятия',
    description: 'Организация мероприятий, свадьбы, корпоративные вечеринки, выставки, конференции'
  },
  {
    title: 'Бизнес-услуги и консалтинг',
    description:
      'Бухгалтерские услуги, консультации по управлению, HR-услуги, маркетинговые исследования'
  },
  {
    title: 'Аренда и лизинг',
    description:
      'Аренда автомобилей, оборудования, недвижимости, финансовый лизинг, аренда спецтехники'
  },
  {
    title: 'Маркетинг и реклама',
    description:
      'Рекламные агентства, цифровой маркетинг, PR-услуги, реклама в социальных сетях, рекламные материалы'
  },
  {
    title: 'Упаковка и материалы',
    description: 'Упаковочные материалы, этикетки, коробки, пленка, упаковочное оборудование'
  },
  {
    title: 'Печатные и графические услуги',
    description: 'Полиграфия, дизайн, печать на ткани, наружная реклама, типографские услуги'
  }
]
